<div class="figure-flags" *ngIf="lines.length">
	<div
		*ngFor="let line of lines; trackBy: trackByLine"
		class="figure-flags__line"
	>
		<typography
			variant="p/xs_medium"
			class="figure-flags__sentence"
			[matTooltip]="line.origin"
			matTooltipPosition="above"
			matTooltipClass="sentiment-tooltip"
		>
			{{ line.sentence }}
		</typography>
		<button
			secondary
			type="button"
			size="extra-small"
			borderColor="transparent"
			textVariant="p/xs_semibold"
			class="figure-flags__action"
			[attr.aria-label]="line.updateLabel"
			(click)="update(line)"
		>
			{{ updateText }}
		</button>
		<typography
			variant="p/xs_medium"
			class="figure-flags__separator"
			aria-hidden="true"
		>
			·
		</typography>
		<button
			secondary
			type="button"
			size="extra-small"
			borderColor="transparent"
			textVariant="p/xs_semibold"
			class="figure-flags__action"
			[attr.aria-label]="line.keepLabel"
			(click)="keep(line)"
		>
			{{ keepText }}
		</button>
	</div>
</div>
